import InterestModal from ".";

import { AnimatePresence } from "framer-motion";
import Overlay from "./overlay";

const DvModal = ({ children, open, onClose }: { children: JSX.Element, open: boolean, onClose: () => void }) => {
  return (
    <AnimatePresence>
      {open && (
        <Overlay close={onClose}>
          <InterestModal>
            {children}
          </InterestModal>
        </Overlay>
      )}
    </AnimatePresence>
  )
}

export default DvModal;